import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      marginBottom: 28,
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 29,
      },
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 40,
      },
    },
    slide: {
      margin: [0, 0, 0, 0],
      height: "auto",
      width: "100%",
      position: "relative",
    },
    swiperCarouselDuration: {
      position: "absolute",
      fontSize: 12,
      color: "#fff",
      right: 10,
      bottom: 10,
      pointerEvents: "none",
      [theme.breakpoints.up("mobile")]: {
        right: 20,
        bottom: 15,
      },
      [theme.breakpoints.up("tablet")]: {
        right: 40,
        bottom: 30,
        fontSize: 18,
      },
    },
    swiperCarouselImageName: {
      position: "absolute",
      left: 10,
      bottom: 0,
      width: "auto",
      height: "35%",
      pointerEvents: "none",
    },
    overlay: {
      background: "linear-gradient(180deg,rgba(0,0,0,0) 0,#000 100%)",
      width: "100%",
      height: "50%",
      position: "absolute",
      bottom: 0,
      left: 0,
      opacity: 0.5,
      pointerEvents: "none",
    },
    title: {
      textAlign: "center",
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(24),
      color: theme.palette.categories.holidays,
      fontWeight: 700,
      marginBottom: 11,
      "& span": {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: theme.typography.pxToRem(19),
        color: theme.palette.primary.main,
        fontWeight: 400,
        display: "block",
      },
      [theme.breakpoints.up("mobile")]: {
        marginBottom: 14,
        fontSize: theme.typography.pxToRem(19),
        "& span": {
          display: "inline",
          fontSize: theme.typography.pxToRem(17),
        },
      },
      [theme.breakpoints.up("tablet")]: {
        textAlign: "left",
        fontSize: theme.typography.pxToRem(28),
        marginBottom: 20,
        "& span": {
          display: "inline",
          fontSize: theme.typography.pxToRem(24),
        },
      },
    },

    "@global": {
      ":root": {
        "--swiper-navigation-size": "30px",
      },
      ".swiper-wrapper": {
        height: "auto",
      },
      ".swiper-button-prev::after": {
        height: 60,
        width: 60,
        boxShadow: "0 2px 3px 0 rgba(37,45,95,.25)",
        position: "absolute",
        background: "rgba(255,255,255,.5)",
        borderRadius: 40,
        zIndex: 10,
        cursor: "pointer",
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        flexWrap: "nowrap",
        paddingLeft: 19,
      },
      ".swiper-button-prev": {
        display: "none",
        fontWeight: "bold",
        color: "rgba(0,0,0,.25)",
        verticalAlign: "top",
        left: 45,
        [theme.breakpoints.up("mobile")]: {
          display: "flex",
        },
      },
      ".swiper-button-next::after": {
        height: 60,
        width: 60,
        boxShadow: "0 2px 3px 0 rgba(37,45,95,.25)",
        position: "absolute",
        background: "rgba(255,255,255,.5)",
        borderRadius: 40,
        zIndex: 10,
        cursor: "pointer",
        display: "flex",
        alignContent: "center",
        paddingLeft: 24,
        alignItems: "center",
        flexWrap: "nowrap",
      },
      ".swiper-button-next": {
        display: "none",
        fontWeight: "bold",
        color: "rgba(0,0,0,.25)",
        verticalAlign: "top",
        right: 45,
        [theme.breakpoints.up("mobile")]: {
          display: "flex",
        },
      },
      ".swiper-slide": {
        display: "flex",
        justifyContent: "center",
        position: "relative",
        height: "auto",
        [theme.breakpoints.up("mobile")]: {
          justifyContent: "stretch",
        },
      },
    },
  }),
  { name: "StarringYouClipsCarousel" },
);
